exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".strikethrough[data-v-6b7bd242]{position:absolute;top:0;text-decoration:line-through;font-size:14px;color:rgba(55,71,79,.7);line-height:1.5em}@media (max-width:768px){.strikethrough[data-v-6b7bd242]{position:relative;display:block;margin-top:.6rem}.price-mobile-position[data-v-6b7bd242]{display:block;line-height:13vw;padding-right:35px}}", ""]);

// exports
